import debug from 'debug';

const enterpriseWebNamespace = 'dart';

export type Debugger = debug.Debugger;

// eslint-disable-next-line import/no-anonymous-default-export
export const Debug = {
  multilanguage: debug(`${enterpriseWebNamespace}:multilanguage`),
  rewrites: debug(`${enterpriseWebNamespace}:rewrites`),
};
